





























































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';

import Toast from '@/mixins/toast';
import CollapseCard from '@/components/UI/CollapseCard.vue';
// Импорт ради Array.prototype.realValuesOrEmpty() в зонных фильтрах
import '@/extensions';
import { getAntDatePickerLocale } from '@/i18n/dateLocale';

import MmAuditorSelect from '../../components/MmAuditorSelect.vue';
import MmHintedButton from '../../components/MmHintedButton.vue';
import MmZoneSelect from '../../components/MmZoneSelect.vue';

import { fetchAuditorOptions } from '../../api/auditors';
import { fetchStoreLevels } from '../../api/catalog';
import { createCancelSource } from '../../api/mmHttp';
import { MM_TASK_LIST_CAPABILITIES, MmTaskListCapabilities } from '../../config/features';
import { isCanceled } from '../../core/errors';
import { listDomainEntries, MmBadgeEntry } from '../../core/statuses';
import { MmAuditor, MmSelectOption } from '../../types/domain';
import { MmStoreLevelsRequest } from '../../types/dto';

const KEY = 'priceMonitoring.mobileMonitoring.tasks.';

/** Имена осей должны совпадать со значениями MmStoreLevelsRequest.type */
type MmZoneAxis = 'format' | 'region' | 'cluster';

interface MmZoneSnapshot {
	formats: number[];
	/** Подписи выбранных форматов — ими фильтрует список, когда id не совпал. */
	formatNames: string[];
	regions: number[];
	regionNames: string[];
	clusters: number[];
	clusterNames: string[];
}

const SEARCH_DEBOUNCE_MS = 350;

const ALL_VALUE = 0;

/** Сентинел «Все» только для показа: на сервер уходит пустой массив или полный набор кодов */
const ALL_KEY = '__all__';

/** Дата без времени и часового пояса: границы суток достраивает сервер */
const DATE_WIRE_FORMAT = 'YYYY-MM-DD';

const DATE_DISPLAY_FORMAT = 'DD.MM.YYYY';

@Component({
	components: {
		CollapseCard,
		MmAuditorSelect,
		MmHintedButton,
		MmZoneSelect,
	},
})
export default class TasksListFilters extends Mixins(Toast) {
	@Prop({ default: null }) readonly tradingId!: number | null;

	@Prop({ default: () => [] }) readonly statuses!: string[];
	@Prop({ default: () => [] }) readonly types!: string[];

	@Prop({ default: '' }) readonly competitorQuery!: string;

	@Prop({ default: () => [] }) readonly formats!: number[];
	@Prop({ default: () => [] }) readonly regions!: number[];
	@Prop({ default: () => [] }) readonly clusters!: number[];

	@Prop({ default: null }) readonly createdFrom!: string | null;
	@Prop({ default: null }) readonly createdTo!: string | null;

	/** Идентификатор аудитора бывает числом и строкой UUID: сравнение через String(), без Number() */
	@Prop({ default: null }) readonly auditorId!: number | string | null;

	@Prop({ default: false }) readonly disabled!: boolean;

	@Prop({ default: false }) readonly hasUserFilters!: boolean;

	@Prop({ default: false }) readonly pendingApply!: boolean;

	@Prop({ default: false }) readonly loading!: boolean;

	formatOptions: MmSelectOption[] = [];
	regionOptions: MmSelectOption[] = [];
	clusterOptions: MmSelectOption[] = [];

	isFormatsLoading: boolean = false;
	isRegionsLoading: boolean = false;
	isClustersLoading: boolean = false;

	auditorOptions: MmAuditor[] = [];
	isAuditorsLoading: boolean = false;
	auditorsFailed: boolean = false;

	competitorText: string = '';

	private searchTimer: number | null = null;

	private formatSource: any = null;
	private regionSource: any = null;
	private clusterSource: any = null;
	private auditorsSource: any = null;

	created(): void {
		this.competitorText = this.competitorQuery;
	}

	mounted(): void {
		this.reloadDictionaries();
	}

	beforeDestroy(): void {
		this.clearSearchTimer();
		this.cancelPendingRequests();
	}

	/** Поле ввода держит своё состояние: при программном сбросе фильтров текст сам не уйдёт */
	@Watch('competitorQuery')
	onCompetitorQueryChanged(next: string): void {
		if (next === this.competitorText.trim()) {
			return;
		}

		this.clearSearchTimer();
		this.competitorText = next;
	}

	get capabilities(): MmTaskListCapabilities {
		return MM_TASK_LIST_CAPABILITIES;
	}

	get isNetworkMissing(): boolean {
		return this.tradingId === null;
	}

	get dateDisplayFormat(): string {
		return DATE_DISPLAY_FORMAT;
	}

	get statusOptions(): MmBadgeEntry[] {
		return listDomainEntries('taskStatus');
	}

	get typeOptions(): MmBadgeEntry[] {
		return listDomainEntries('taskType');
	}

	get statusSelectValue(): string[] {
		if (this.statuses.length === 0) {
			return [ALL_KEY];
		}

		if (this.isEveryOptionSelected(this.statuses, this.statusOptions)) {
			return [ALL_KEY];
		}

		return this.statuses.slice();
	}

	get typeSelectValue(): string[] {
		if (this.types.length === 0) {
			return [ALL_KEY];
		}

		if (this.isEveryOptionSelected(this.types, this.typeOptions)) {
			return [ALL_KEY];
		}

		return this.types.slice();
	}

	get statusSelectOptions(): any[] {
		const entries: any[] = [{ code: ALL_KEY, label: this.$t('shared.selectBox.all') as string }];
		const source = this.statusOptions;

		for (let i = 0; i < source.length; i += 1) {
			entries.push({
				code: source[i].code,
				label: this.$t(source[i].spec.labelKey) as string,
			});
		}

		return entries;
	}

	get typeSelectOptions(): any[] {
		const entries: any[] = [{ code: ALL_KEY, label: this.$t('shared.selectBox.all') as string }];
		const source = this.typeOptions;

		for (let i = 0; i < source.length; i += 1) {
			entries.push({
				code: source[i].code,
				label: this.$t(source[i].spec.labelKey) as string,
			});
		}

		return entries;
	}

	get unavailableHint(): string {
		return this.$t(KEY + 'filterUnavailableHint') as string;
	}

	get canReset(): boolean {
		return !this.disabled && this.hasUserFilters;
	}

	get resetDisabledReason(): string {
		if (this.isNetworkMissing) {
			return this.$t('priceMonitoring.mobileMonitoring.states.networkNotSelected') as string;
		}

		if (this.disabled) {
			return this.$t('priceMonitoring.mobileMonitoring.states.loading') as string;
		}

		return '';
	}

	get applyDisabledReason(): string {
		if (this.isNetworkMissing) {
			return this.$t('priceMonitoring.mobileMonitoring.states.networkNotSelected') as string;
		}

		return this.$t('priceMonitoring.mobileMonitoring.states.loading') as string;
	}

	get auditorNote(): string {
		if (!this.capabilities.auditorFilter) {
			return this.unavailableHint;
		}

		if (this.auditorsFailed) {
			return this.$t('priceMonitoring.mobileMonitoring.assignments.auditorsLoadError') as string;
		}

		return '';
	}

	get auditorDisabledReason(): string {
		if (!this.capabilities.auditorFilter) {
			return this.unavailableHint;
		}

		if (this.isNetworkMissing) {
			return this.$t('priceMonitoring.mobileMonitoring.states.networkNotSelected') as string;
		}

		return this.$t('priceMonitoring.mobileMonitoring.states.loading') as string;
	}

	get formatPlaceholder(): string {
		return this.isFormatsLoading ? (this.$t('regular.loading.formatsChannels') as string) : '';
	}

	get regionPlaceholder(): string {
		return this.isRegionsLoading ? (this.$t('regular.loading.regions') as string) : '';
	}

	get clusterPlaceholder(): string {
		return this.isClustersLoading ? (this.$t('regular.loading.clusters') as string) : '';
	}

	get datePickerLocale(): any {
		return getAntDatePickerLocale();
	}

	/** a-range-picker понимает только moment; наружу отдаём строки, чтобы состояние сохранялось */
	get periodValue(): any[] {
		const from = this.createdFrom;
		const to = this.createdTo;

		if (!from && !to) {
			return [];
		}

		return [
			from ? moment(from, DATE_WIRE_FORMAT) : null,
			to ? moment(to, DATE_WIRE_FORMAT) : null,
		];
	}

	isControlDisabled(supported: boolean): boolean {
		return this.disabled || this.isNetworkMissing || !supported;
	}

	fieldLabelId(field: string): string {
		return 'sm-mobilemon-tasks-filters-' + field + '-label-' + String((this as any)._uid);
	}

	/** Служебное значение «Все» срезаем перед отправкой: наружу уходит пустой список или коды */
	handleStatusesChange(next: string[]): void {
		const list = next ? next.slice() : [];

		if (list.length === 0) {
			this.$emit('change-statuses', []);

			return;
		}

		const last = list[list.length - 1];

		if (last === ALL_KEY) {
			this.$emit('change-statuses', []);

			return;
		}

		this.$emit('change-statuses', list.filter((item) => item !== ALL_KEY));
	}

	handleTypesChange(next: string[]): void {
		const list = next ? next.slice() : [];

		if (list.length === 0) {
			this.$emit('change-types', []);

			return;
		}

		const last = list[list.length - 1];

		if (last === ALL_KEY) {
			this.$emit('change-types', []);

			return;
		}

		this.$emit('change-types', list.filter((item) => item !== ALL_KEY));
	}

	handleCompetitorInput(event: any): void {
		const value = event && event.target ? String(event.target.value) : '';

		this.competitorText = value;
		this.clearSearchTimer();
		this.searchTimer = window.setTimeout(() => {
			this.searchTimer = null;
			this.commitCompetitor();
		}, SEARCH_DEBOUNCE_MS);
	}

	handleCompetitorSubmit(): void {
		this.clearSearchTimer();
		this.commitCompetitor();
	}

	/** Наружу уходит пара идентификатор и логин, а в запрос попадает только логин */
	handleAuditorChange(next: any): void {
		/** Тип any намеренно: очистка приходит как null, undefined или пустая строка, а id бывает строкой */
		const id: number | string | null = next === null || next === undefined || next === ''
			? null
			: next;
		const found = this.findAuditorById(id);

		this.$emit('change-auditor', id, found !== null ? found.login : null);
	}

	/** Сравниваем отсортированные копии: MultiSelect шлёт событие и на программную установку — иначе цикл */
	handleFormatChange(next: number[]): void {
		const value = next ? next.slice() : [];

		if (this.isSameIdList(value, this.formats)) {
			return;
		}

		const zone: MmZoneSnapshot = {
			formats: value,
			formatNames: this.labelsOf(this.formatOptions, value),
			regions: [],
			regionNames: [],
			clusters: [],
			clusterNames: [],
		};

		this.$emit('change-zone', zone);
		// Зону передаём параметром: проп обновится позже, и чтение из this дало бы прошлый формат
		this.loadLevel('region', zone);
		this.loadLevel('cluster', zone);
	}

	handleRegionChange(next: number[]): void {
		const value = next ? next.slice() : [];

		if (this.isSameIdList(value, this.regions)) {
			return;
		}

		const zone: MmZoneSnapshot = {
			formats: this.formats.slice(),
			formatNames: this.labelsOf(this.formatOptions, this.formats),
			regions: value,
			regionNames: this.labelsOf(this.regionOptions, value),
			clusters: [],
			clusterNames: [],
		};

		this.$emit('change-zone', zone);
		this.loadLevel('cluster', zone);
	}

	handleClusterChange(next: number[]): void {
		const value = next ? next.slice() : [];

		if (this.isSameIdList(value, this.clusters)) {
			return;
		}

		const zone: MmZoneSnapshot = {
			formats: this.formats.slice(),
			formatNames: this.labelsOf(this.formatOptions, this.formats),
			regions: this.regions.slice(),
			regionNames: this.labelsOf(this.regionOptions, this.regions),
			clusters: value,
			clusterNames: this.labelsOf(this.clusterOptions, value),
		};

		this.$emit('change-zone', zone);
	}

	/** Второй аргумент — строки в формате показа; для сервера форматируем сами из объектов moment */
	handlePeriodChange(dates: any[]): void {
		const list = dates && dates.length === 2 ? dates : [];
		const from = list.length === 2 && list[0] ? list[0].format(DATE_WIRE_FORMAT) : null;
		const to = list.length === 2 && list[1] ? list[1].format(DATE_WIRE_FORMAT) : null;

		this.$emit('change-period', from, to);
	}

	handleReset(): void {
		this.clearSearchTimer();
		this.competitorText = '';
		this.$emit('reset');
	}

	/** Сначала досылаем набранный текст поиска: его дребезг мог ещё не сработать */
	handleApply(): void {
		if (this.loading) {
			return;
		}

		this.clearSearchTimer();
		this.commitCompetitor();
		this.$emit('apply');
	}

	/** Подписку на готовность сессии держит только TasksList, иначе будет две волны запросов */
	reloadDictionaries(): void {
		if (this.tradingId === null) {
			return;
		}

		const zone: MmZoneSnapshot = {
			formats: this.formats.slice(),
			formatNames: this.labelsOf(this.formatOptions, this.formats),
			regions: this.regions.slice(),
			regionNames: this.labelsOf(this.regionOptions, this.regions),
			clusters: this.clusters.slice(),
			clusterNames: this.labelsOf(this.clusterOptions, this.clusters),
		};

		this.loadLevel('format', zone);
		this.loadLevel('region', zone);
		this.loadLevel('cluster', zone);

		this.loadAuditors();
	}

	/** Родители уходят без сентинела 0 («Все»): иначе бэкенд примет его за идентификатор */
	private buildLevelsRequest(axis: MmZoneAxis, zone: MmZoneSnapshot): MmStoreLevelsRequest {
		const formats = zone.formats.slice().realValuesOrEmpty();
		const regions = zone.regions.slice().realValuesOrEmpty();

		return {
			tradingNetworkId: this.tradingId as number,
			type: axis,
			storeFormat: axis === 'format' ? [] : formats,
			storeRegion: axis === 'cluster' ? regions : [],
			storeCluster: [],
		};
	}

	private loadLevel(axis: MmZoneAxis, zone: MmZoneSnapshot): void {
		if (this.tradingId === null || !this.capabilities.zoneFilter) {
			return;
		}

		const previous = this.readSource(axis);

		if (previous !== null) {
			previous.cancel();
		}

		const source = createCancelSource();

		this.writeSource(axis, source);
		this.setAxisLoading(axis, true);

		fetchStoreLevels(this.buildLevelsRequest(axis, zone), { cancelToken: source.token })
			.then((response) => {
				if (this.readSource(axis) !== source) {
					return;
				}

				const data = response.data;
				const items = data && Array.isArray(data.items) ? data.items : [];

				this.setAxisOptions(axis, items.length > 0 ? items : this.buildAllOnlyOptions());
			})
			.catch((error) => {
				if (isCanceled(error) || this.readSource(axis) !== source) {
					return;
				}

				this.setAxisOptions(axis, this.buildAllOnlyOptions());
				this.showError(this.$t('http.errors.loadFilters3') as string);
			})
			.finally(() => {
				if (this.readSource(axis) !== source) {
					return;
				}

				this.writeSource(axis, null);
				this.setAxisLoading(axis, false);
			});
	}

	private loadAuditors(): void {
		if (this.tradingId === null || !this.capabilities.auditorFilter) {
			return;
		}

		if (this.auditorsSource !== null) {
			this.auditorsSource.cancel();
		}

		const source = createCancelSource();

		this.auditorsSource = source;
		this.isAuditorsLoading = true;
		this.auditorsFailed = false;

		fetchAuditorOptions({ cancelToken: source.token })
			.then((response) => {
				if (this.auditorsSource !== source) {
					return;
				}

				this.auditorOptions = Array.isArray(response.data) ? response.data : [];
			})
			.catch((error) => {
				if (isCanceled(error) || this.auditorsSource !== source) {
					return;
				}

				this.auditorOptions = [];
				this.auditorsFailed = true;
			})
			.finally(() => {
				if (this.auditorsSource !== source) {
					return;
				}

				this.auditorsSource = null;
				this.isAuditorsLoading = false;
			});
	}

	private commitCompetitor(): void {
		const next = this.competitorText.trim();

		if (next === this.competitorQuery) {
			return;
		}

		this.$emit('change-competitor', next);
	}

	private clearSearchTimer(): void {
		if (this.searchTimer !== null) {
			window.clearTimeout(this.searchTimer);
			this.searchTimer = null;
		}
	}

	/** id сравниваем как строки: справочник даёт UUID, а снимок фильтра — числа */
	private findAuditorById(id: number | string | null): MmAuditor | null {
		if (id === null) {
			return null;
		}

		const key = String(id);

		for (let i = 0; i < this.auditorOptions.length; i += 1) {
			if (String(this.auditorOptions[i].id) === key) {
				return this.auditorOptions[i];
			}
		}

		return null;
	}

	private labelsOf(options: MmSelectOption[], ids: number[]): string[] {
		const labels: string[] = [];

		for (let i = 0; i < ids.length; i += 1) {
			const id = ids[i];

			if (id === ALL_VALUE) {
				continue;
			}

			for (let j = 0; j < options.length; j += 1) {
				const option = options[j];

				if (option.value === id && typeof option.label === 'string' && option.label !== '') {
					labels.push(option.label);
					break;
				}
			}
		}

		return labels;
	}

	private buildAllOnlyOptions(): MmSelectOption[] {
		return [{ value: ALL_VALUE, label: this.$t('shared.selectBox.all') as string }];
	}

	private readSource(axis: MmZoneAxis): any {
		if (axis === 'format') {
			return this.formatSource;
		}

		if (axis === 'region') {
			return this.regionSource;
		}

		return this.clusterSource;
	}

	private writeSource(axis: MmZoneAxis, source: any): void {
		if (axis === 'format') {
			this.formatSource = source;

			return;
		}

		if (axis === 'region') {
			this.regionSource = source;

			return;
		}

		this.clusterSource = source;
	}

	private setAxisOptions(axis: MmZoneAxis, items: MmSelectOption[]): void {
		if (axis === 'format') {
			this.formatOptions = items;

			return;
		}

		if (axis === 'region') {
			this.regionOptions = items;

			return;
		}

		this.clusterOptions = items;
	}

	private setAxisLoading(axis: MmZoneAxis, value: boolean): void {
		if (axis === 'format') {
			this.isFormatsLoading = value;

			return;
		}

		if (axis === 'region') {
			this.isRegionsLoading = value;

			return;
		}

		this.isClustersLoading = value;
	}

	private cancelPendingRequests(): void {
		if (this.formatSource !== null) {
			this.formatSource.cancel();
			this.formatSource = null;
		}

		if (this.regionSource !== null) {
			this.regionSource.cancel();
			this.regionSource = null;
		}

		if (this.clusterSource !== null) {
			this.clusterSource.cancel();
			this.clusterSource = null;
		}

		if (this.auditorsSource !== null) {
			this.auditorsSource.cancel();
			this.auditorsSource = null;
		}

		this.isFormatsLoading = false;
		this.isRegionsLoading = false;
		this.isClustersLoading = false;
		this.isAuditorsLoading = false;
	}

	private isEveryOptionSelected(list: string[], options: MmBadgeEntry[]): boolean {
		if (!options || options.length === 0) {
			return false;
		}

		if (list.length !== options.length) {
			return false;
		}

		for (let i = 0; i < options.length; i += 1) {
			if (list.indexOf(options[i].code) < 0) {
				return false;
			}
		}

		return true;
	}

	private isSameIdList(a: number[], b: number[]): boolean {
		if (a.length !== b.length) {
			return false;
		}

		const left = a.slice().sort();
		const right = b.slice().sort();

		for (let i = 0; i < left.length; i += 1) {
			if (left[i] !== right[i]) {
				return false;
			}
		}

		return true;
	}
}
